/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import { Paper } from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import { Navbar } from '../components';
import { variables } from '../components/Variables';
import CommonCalendar from './CommonCalendar';
import TrendsbySKU from './TrendsbySKU';
import LoadingOverlay from '../components/LoadingOverlay';
import TrendsbyVendor from './TrendsbyVendor';

const ReceivingTrends = () => {
  const defaultStartDate = new Date(
    new Date(new Date().getTime()).setDate(new Date().getDate() - 7),
  );
  const defaultEndDate = new Date(
    new Date(new Date().getTime()).setDate(new Date().getDate() - 1),
  );
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);
  const [graphData, setGraphData] = useState([]);
  const [vendorGraphData, setVendorGraphData] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [activePill, setActivePill] = useState('home');
  const { activeMenu, setVendorValue, vendorValue } = useStateContext();
  const navigate = useNavigate();
  const isMounted = useRef(false);

  useEffect(() => {
    if (activePill === 'home') {
      setVendorValue(null);
      fetchReceivingTrend();
    } else {
      ReceivingTrendByVendor();
    }
  }, [activePill]);
  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        VendorList();
      }
    }
  }, []);
  useEffect(() => {
    if (startDate === null || endDate === null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Select Date!',
      });
      setStartDate(defaultStartDate); // for compulsory dates
      setEndDate(defaultEndDate); // for compulsory dates
    }
  }, [startDate, endDate]);
  const userInfo = !!localStorage.getItem('loginID')
    && JSON.parse(localStorage.getItem('loginID'));

  const VendorList = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${variables.BASE_URL}VendorList`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const Data = response.data;
      if (Data.IsSuccess) {
        const vendorlist = Data.vendorlist.map((item) => ({
          value: item?.trim(),
          label: item?.trim(),
        }));
        setVendorList(vendorlist);
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error,
      });
    }
    setLoading(false);
  };

  const handlePillClick = (pill) => {
    setActivePill(pill);
    setStartDate(defaultStartDate);
    setEndDate(defaultEndDate);
  };

  // BELOW CODE FOR DATE SELECTION START TO END******
  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (startDate && startDate > date) {
      setStartDate(date);
    }
  };
  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (endDate && endDate < date) {
      setEndDate(date);
      document.getElementById('datePicker_idend').focus();
    }
  };
  const disableFutureDates = (date) => date.getTime() < new Date().getTime();

  const fetchReceivingTrend = async () => {
    setLoading(true);
    try {
      const data = {
        UserId: userInfo.UserId,
        ProcessName: variables.PROCESSNAME,
        PageName: 'Receiving Trends',
        FromDate: startDate,
        ToDate: endDate,
      };

      const response = await axios.post(
        `${variables.BASE_URL}ReceivingTrend`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      const Data = response.data;
      if (Data.IsSuccess && Data.IsAuthorize) {
        setGraphData(Data.ReceivingTrend);
      } else if (!Data.IsAuthorize) {
        setGraphData([]);
        setTimeout(() => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Access Denied!',
          });
          navigate('/');
        }, 0);
      } else {
        setGraphData([]);
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: Data.Reason,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error,
      });
      setGraphData([]);
    }
    setLoading(false);
  };

  const ReceivingTrendByVendor = async () => {
    setLoading(true);
    try {
      const data = {
        UserId: userInfo.UserId,
        ProcessName: variables.PROCESSNAME,
        PageName: 'Receiving Trends',
        FromDate: startDate,
        ToDate: endDate,
        Vendor: vendorValue?.value || vendorList[0]?.value || '',
      };

      const response = await axios.post(
        `${variables.BASE_URL}ReceivingTrendByVendor`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      const Data = response.data;
      if (Data.IsSuccess && Data.IsAuthorize) {
        setVendorGraphData(Data.ReceivingTrendByVendor);
      } else if (!Data.IsAuthorize) {
        setVendorGraphData([]);
        setTimeout(() => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Access Denied!',
          });
          navigate('/');
        }, 0);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: Data.Reason,
        });
        setVendorGraphData([]);
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error,
      });
      setVendorGraphData([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}
      <div
        style={{
          width: `${activeMenu ? '100%' : '100%'} `,
          paddingLeft: `${activeMenu ? '300px' : '0px'}`,
        }}
      >
        <div
          className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full "
          id="navMenu_id"
        >
          <Navbar />
          <CommonCalendar
            loading={loading}
            startDate={startDate}
            handleStartDateChange={handleStartDateChange}
            endDate={endDate}
            disableFutureDates={disableFutureDates}
            handleEndDateChange={handleEndDateChange}
            bySKU={fetchReceivingTrend}
            byVendor={ReceivingTrendByVendor}
            activePill={activePill}
            vendorList={vendorList}
          />
        </div>

        <div className="container-fluid">
          <ul className="nav nav-pills" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activePill === 'home' ? 'active' : ''}`}
                id="home-tab"
                data-bs-toggle="tab"
                data-bs-target="#home"
                type="button"
                role="tab"
                aria-controls="home"
                aria-selected={activePill === 'home'}
                style={{
                  width: '200px',
                  fontSize: '20px',
                  backgroundColor: activePill === 'home' ? '#ffb013' : '',
                  color: activePill === 'home' ? 'black' : '',
                }}
                onClick={() => handlePillClick('home')}
              >
                <strong>Trends By SKU</strong>
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${
                  activePill === 'profile' ? 'active' : ''
                }`}
                id="profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#profile"
                type="button"
                role="tab"
                aria-controls="profile"
                aria-selected={activePill === 'profile'}
                style={{
                  width: '200px',
                  fontSize: '20px',
                  backgroundColor: activePill === 'profile' ? '#ffb013' : '',
                  color: activePill === 'profile' ? 'black' : '',
                }}
                onClick={() => handlePillClick('profile')}
              >
                <strong>Trends By Vendor</strong>
              </button>
            </li>
          </ul>
          <div className=" tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              {loading ? (
                <LoadingOverlay />
              ) : (
                <Paper className="GraphContainerBg">
                  <TrendsbySKU
                    graphData={graphData}
                    loading={loading}
                    setLoading={setLoading}
                  />
                </Paper>
              )}
            </div>
            <div
              className="tab-pane fade"
              id="profile"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div className="container-fluid">
                <Paper className="GraphContainerBg">
                  <TrendsbyVendor
                    graphData={vendorGraphData}
                    loading={loading}
                    setLoading={setLoading}
                  />
                </Paper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceivingTrends;
